module.exports = __webpack_public_path__ + "img/iq.0325674f.svg";